export default "__VITE_ASSET__$z7EqKiv__"